


























import { Component, Vue } from 'vue-property-decorator';
import FeedItem from '@/components/NewsFeed/FeedItem.vue';
import { Views, ViewModes, Actions, Mutations } from '@/ts/store/Constants';
import FeedItemData from '@/ts/FeedItemData';

@Component({
  components: {
    FeedItem,
  },
})
export default class NewsFeed extends Vue {
    private feedItems: FeedItemData[] = [];

    constructor() {
        super();

        // TODO (CKJ): Purge mocked data
      
    }

    public created() {
        this.$store.commit(Mutations.SET_APP_DASHBOARD_NOTIFICATION_PAGE, 'all');
        this.$store.dispatch(Actions.FETCH_NOTIFICATIONS, {type: 'all', interval: null});
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Notifications, 
            viewMode: ViewModes.Notifications.All,
        });        
    }

    get feedItemData(): any {
        return this.$store.getters['Notifications/getFeedItemData'];
    }

}
